import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  public constructor(private readonly _router: Router) {}

  public navigateToLogin(): void {
    this._router.navigate(['login']);
  }

  public navigateToLandingPage(): void {
    this._router.navigate(['dashboard']);
  }
}
